import React from "react";
import {
    Link
} from "react-router-dom";
import {
    Alert,
    Table
} from "react-bootstrap";
import PropTypes from "prop-types";

import Loading from "../../components/Loading";
import DiscountCodeTypePill from "./components/DiscountCodeTypePill";
import PriceFormatter from "../../components/priceFormatter";

function formatDiscount(discountCode) {
    const parts = [];
    if(discountCode.discountValue !== null) {
        parts.push(<PriceFormatter key="value" price={ discountCode.discountValue }/>);
    }
    if(discountCode.discountPercentage !== null) {
        parts.push(<span key="percentage">{ Math.round(discountCode.discountPercentage * 100) }%</span>);
    }
    if(parts.length === 2) {
        return <React.Fragment>{ parts[0] } + { parts[1] }</React.Fragment>;
    }
    if(parts.length === 1) {
        return parts[0];
    }
    return "-";
}

function formatUsage(discountCode) {
    const count = discountCode.usageCount;
    const max = discountCode.maxUsageValue;
    if(max === null) {
        return count + " / onbeperkt";
    }
    return count + " / " + max;
}

function DiscountCodesTable({ discountCodes, error, baseUrl, onToggleEnabled }) {
    return (
        <Table size="sm" className="results" hover={ discountCodes && discountCodes.length > 0 }>
            <thead className="thead-light">
            <tr>
                <th className="text-center">#</th>
                <th className="text-left">Code</th>
                <th className="text-left">Type</th>
                <th className="text-left">Korting</th>
                <th className="text-left">Gebruik</th>
                <th className="text-center">Actief</th>
            </tr>
            </thead>
            <tbody>
            { error ? (
                <tr>
                    <td colSpan={ 6 }>
                        <Alert variant="danger" className="mb-0">{ error }</Alert>
                    </td>
                </tr>
            ) : discountCodes === null ? (
                <tr>
                    <td colSpan={ 6 }>
                        <Loading/>
                    </td>
                </tr>
            ) : discountCodes.length === 0 ? (
                <tr>
                    <td colSpan={ 6 } className="text-center">
                        <h1><i className="fas fa-tags"/></h1>
                        <h4>Geen kortingscodes</h4>
                        <p>Er zijn nog geen kortingscodes aangemaakt.</p>
                    </td>
                </tr>
            ) : discountCodes.map((discountCode) => {
                const url = baseUrl + "/discount-code/" + discountCode.id;
                return (
                    <tr key={ discountCode.id } className="table-clickable-row">
                        <th scope="row" className="align-middle text-center">
                            <Link to={ url }>
                                { discountCode.id }
                            </Link>
                        </th>
                        <td className="align-middle">
                            <Link to={ url }>
                                { discountCode.code }
                            </Link>
                        </td>
                        <td className="align-middle">
                            <Link to={ url }>
                                <DiscountCodeTypePill type={ discountCode.type }/>
                            </Link>
                        </td>
                        <td className="align-middle">
                            <Link to={ url }>
                                { formatDiscount(discountCode) }
                            </Link>
                        </td>
                        <td className="align-middle">
                            <Link to={ url }>
                                { formatUsage(discountCode) }
                            </Link>
                        </td>
                        <td className="align-middle text-center">
                            <div className="custom-control custom-switch d-inline-block">
                                <input
                                    type="checkbox"
                                    className="custom-control-input"
                                    id={ `enabled-${discountCode.id}` }
                                    checked={ discountCode.enabled }
                                    onChange={ () => onToggleEnabled(discountCode.id, !discountCode.enabled) }
                                />
                                <label className="custom-control-label" htmlFor={ `enabled-${discountCode.id}` } aria-label="Inschakelen"/>
                            </div>
                        </td>
                    </tr>
                )
            })}
            </tbody>
        </Table>
    );
}
DiscountCodesTable.propTypes = {
    discountCodes: PropTypes.array,
    error: PropTypes.string,
    baseUrl: PropTypes.string.isRequired,
    onToggleEnabled: PropTypes.func.isRequired,
};

export default React.memo(DiscountCodesTable);
